/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'
import desktopBrandLogo from './commonwealth_brandstudio_web_logo.svg'

const BrandLogoDesktop = () => (
  <img
    alt="Commonwealth Logo"
    src={desktopBrandLogo}
    sx={{ width: 214, height: 40, mt: 1 }}
  />
)

BrandLogoDesktop.propTypes = {
  color: string,
  height: number,
}

export default BrandLogoDesktop
